// src/features/executive/account/hooks/use-advance.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import AccountApi from 'api/executive/account.api'
import type {
  AdvanceResponse,
  GetAccountFlowParams,
} from 'api/executive/executive.types'

export function useAdvance() {
  return useExecutiveQuery<GetAccountFlowParams, AdvanceResponse>(
    'account.advance',
    AccountApi.getAdvance,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        paymentType: f.paymentType ?? undefined,
      }
    }
  )
}
